<template>
  <div>
    <div class="text-center" style="border-top:1px solid #ccc; padding:10px 0;">
      <b-alert show variant="primary" style="margin:0 auto; display:inline-block">
        Saldo Acumulado Inicio: {{saldoAcumuladoInicio}}
      </b-alert>
      <b-alert show variant="primary" style="margin:0 auto 0 15px; display:inline-block">
        Saldo Anterior en Pesos: {{saldoAcumuladoInicioPesos}}
      </b-alert>      
    </div>
    <b-table
      :items="results"
      :fields="columns.map(x => x.checked?x:null).filter(y => y!==null)"
      :per-page="perPage"
      :current-page="currentPage"
      style="margin-bottom:0;"
      responsive     
    />
    <!--div class="text-center" style="border-top:1px solid #ccc; padding:10px 0;">
      <b-alert show variant="primary" style="margin:0 auto; display:inline-block">
        {{bottom_msg_a}}
      </b-alert>
      <b-alert show variant="primary" style="margin:0 auto 0 15px; display:inline-block">
        {{bottom_msg_b}}
      </b-alert>
      <b-alert show variant="primary" style="margin:0 auto 0 15px; display:inline-block">
        {{bottom_msg_c}}
      </b-alert>
      <b-alert show variant="primary" style="margin:0 auto 0 15px; display:inline-block">
        {{bottom_msg_d}}
      </b-alert>
    </div-->
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="results.length"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { currencyFormat, currencyFormatUsd, numberFormat } from '@/helpers/filters'
import moment from 'moment'
export default {
  props:
    ['results', 'saldoAcumuladoInicio', 'saldoAcumuladoInicioPesos']
  ,
  computed: {    
    /*bottom_msg_a: function() {
      let pesos = 0;
      this.$store.state.cuenta_corriente.forEach(item => {
        if (item.nro_poliza != 0) {
          if(item.txt_desc_moneda == 'Pesos' || item.txt_desc_moneda == 'pesos'){
            const comisiones = parseFloat(item.comisiones);
            if(!isNaN(comisiones) && comisiones != undefined){
              pesos += comisiones;
            }
          }
        }
      });
      return (pesos > 0) ? ('Comisiones BRUTAS en pesos: ' + currencyFormat(pesos) ) : 'Sin comisiones BRUTAS en pesos.';
    },
    bottom_msg_b: function() {
      let dolares = 0;
      this.$store.state.cuenta_corriente.forEach(item => {
        if (item.nro_poliza != 0) {
          if(item.txt_desc_moneda != 'Pesos'){
            const comisiones = parseFloat(item.comisiones);
            if(!isNaN(comisiones) && comisiones != undefined){
              dolares += comisiones;
            }
          }
        }
      });
      return 'Comisiones BRUTAS en dolares: ' + currencyFormatUsd(dolares); 
    },
    bottom_msg_c: function() {
      let pesos = 0;
      this.$store.state.cuenta_corriente.forEach(item => {
        if(item.txt_desc_moneda == 'Pesos' || item.txt_desc_moneda == 'pesos'){
          const comisiones = parseFloat(item.COMISIONES_NETAS);
          if(!isNaN(comisiones) && comisiones != undefined){
            pesos += comisiones;
          }
        }
      });
      return (pesos > 0) ? ('Comisiones NETAS en pesos: ' + currencyFormat(pesos) ) : 'Sin comisiones NETAS en pesos.';
    },
    bottom_msg_d: function() {
      let dolares = 0;
      this.$store.state.cuenta_corriente.forEach(item => {
        if(item.txt_desc_moneda != 'Pesos'){
          const comisiones = parseFloat(item.COMISIONES_NETAS);
          if(!isNaN(comisiones) && comisiones != undefined){
            dolares += comisiones;
          }
        }
      });
      return 'Comisiones NETAS en dolares: ' + currencyFormatUsd(dolares); 
    }*/
  },
  data () {
    return {
      currentPage: 1,
      perPage: 10,
      columns: [
        {
          key: 'fec_registro',
          label: 'Fecha',
          formatter: value => moment(value).format('DD/MM/YY'),
          checked: true

        },
        {
          key: 'recibo',
          label: 'Recibo',
          checked: false
        },
        {
          key: 'ramo',
          label: 'Ramo',
          checked: false
        },
        {
          key: 'nro_poliza',
          label: 'Póliza',
          checked: true
        },
        {
          key: 'nro_endoso',
          label: 'Endoso',
          checked: true
        },
        {
          key: 'cuota',
          label: 'Cuota',
          checked: true
        },
        {
          key: 'asegurado',
          label: 'Asegurado',
          checked: false
        },
        {
          key: 'txt_desc_moneda',
          label: 'Moneda',
          checked: true
        },
        {
          key: 'premio',
          label: 'Premio',
          formatter: value => currencyFormat(value),
          checked: true
        },
        {
          key: 'prima',
          label: 'Prima',
          formatter: value => currencyFormat(value),
          checked: true
        },
        {
          key: 'Pje_Comision',
          label: 'Pje. Comision',
          checked: true
        },
        {
          key: 'comisiones',
          label: 'Comision',
          formatter: value => numberFormat(value),
          checked: true
        },
        {
          key: 'II_BB',
          label: 'IIBB',
          formatter: value => currencyFormat(value),
          checked: true
        },
        {
          key: 'Serv_Soc',
          label: 'S. Sociales',
          formatter: value => currencyFormat(value),
          checked: true
        },
        {
          key: 'RETENCIONES',
          label: 'Retenciones',
          checked: true
        },
        {
          key: 'COMISIONES_NETAS',
          label: 'Comisiones Netas',
          checked: true
        }
      ]
    }
  }
}
</script>
